module.exports = __webpack_public_path__ + "media/img/decorations/testing-myths-img-right-7ffe35dee8949aa8468585883b53719c.svg";